import React from "react";

const PHOTO_URL =
  "https://customer-assets.emergentagent.com/job_chudy-logistyka/artifacts/rp359rx3_cv.jpg";

const stats = [
  { n: "10+", l: "lat w branży transportowej" },
  { n: "50+", l: "firm wsparłem w rozwoju" },
  { n: "100%", l: "praktyki zamiast teorii" },
];

export default function About() {
  return (
    <section id="o-mnie" data-testid="about-section" className="section grain relative">
      <div className="container-x relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <div className="sticky top-28 space-y-8">
              <div className="relative group">
                <div className="absolute -inset-3 border border-[rgba(212,169,74,0.25)] pointer-events-none" />
                <div className="absolute -inset-6 border border-[rgba(212,169,74,0.1)] pointer-events-none" />
                <div className="relative overflow-hidden bg-[#0e0e10]">
                  <img
                    src={PHOTO_URL}
                    alt="Przemysław Chudy"
                    data-testid="about-photo"
                    className="w-full h-auto object-cover aspect-[4/5] grayscale-[15%] group-hover:grayscale-0 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent opacity-60 pointer-events-none" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="text-[11px] tracking-[0.3em] uppercase gold-text">
                      Przemysław Chudy
                    </div>
                    <div className="text-[13px] text-[#b8b3a7] mt-1">
                      Doradca i praktyk transportu
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 pt-2">
                {stats.map((s) => (
                  <div key={s.l} className="border-l border-[rgba(212,169,74,0.3)] pl-3">
                    <div className="stat-number text-[32px] md:text-[40px]">{s.n}</div>
                    <div className="text-[10px] uppercase tracking-[0.18em] text-[#b8b3a7] mt-2 leading-snug">
                      {s.l}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-7 text-[16px] md:text-[17px] leading-[1.85] text-[#c9c4b8]">
            <p>
              Nazywam się <span className="text-[#f5f1e8] font-semibold">Przemysław Chudy</span> i
              od ponad 10 lat działam w branży transportowej i spedycyjnej.
              Budowałem i zarządzałem działami spedycji, odpowiadałem za rozwój
              operacyjny firm, prowadziłem zespoły oraz optymalizowałem procesy
              logistyczne w realnych warunkach rynkowych.
            </p>
            <p>
              Znam tę branżę od środka — od pierwszego zlecenia, przez rozwój
              floty i zespołu, aż po sytuacje kryzysowe, które potrafią
              zachwiać całym biznesem.
            </p>
            <div className="pt-4">
              <div className="text-[13px] tracking-[0.24em] uppercase gold-text mb-5">
                Dziś pomagam firmom:
              </div>
              <ul className="space-y-4">
                {[
                  "budować spedycję i transport od zera",
                  "uporządkować chaos operacyjny",
                  "zwiększać rentowność i marże",
                  "wychodzić z zadłużenia i problemów finansowych",
                ].map((item, i) => (
                  <li key={i} className="flex gap-4 group">
                    <span className="text-[var(--gold)] font-display text-[18px] leading-none mt-1.5">
                      0{i + 1}
                    </span>
                    <span className="flex-1 text-[#e8e3d5] group-hover:text-white transition-colors">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <blockquote className="mt-10 pl-6 border-l-2 border-[var(--gold)] py-2">
              <p className="font-display italic text-[22px] md:text-[26px] leading-snug text-[#f5f1e8]">
                „Nie sprzedaję teorii. Pokazuję rozwiązania, które działają."
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}
